const browser = {
  setTabTitle(title) {
    document.title = title;
  }
};

export default browser;
